import { render, staticRenderFns } from "./RoomSelector.vue?vue&type=template&id=a3270634&"
import script from "./RoomSelector.vue?vue&type=script&lang=js&"
export * from "./RoomSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports